import * as React from "react";
import { ReplaySearchButtonComponent } from "views/components/widgets/ReplaySearchButton";
const ReplayLinkWidgetActionComponent = ({ widget }) => {
  const href = widget.context;
  if (!href) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ReplaySearchButtonComponent, { searchLink: href });
};
const replayLinkWidgetAction = {
  type: "welcome-replay-link",
  position: "menu",
  showInNonInteractiveMode: true,
  component: ReplayLinkWidgetActionComponent
};
export default replayLinkWidgetAction;
